<template>
  <ExamResult :path="'/continueEdu'" style="margin-top: -86px;"></ExamResult>
</template>

<script>
  import ExamResult from '@/page/modules/exam/result'
  export default {
    components: { ExamResult },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/exam/result.vue